import { Link } from "react-router-dom";
import { outResource } from "utils/util";
import Logo from "component/Logo";

const DESCRIPTION = "치과의사만의 커뮤니티, 그 이상";

const COMPANY_NAME = "(주)데니어";
const REPRESENTATIVE = "송언의";
const ADDRESS = "전북특별자치도 전주시 덕진구 기린대로 886 2층 201호(여의동2가)";
const PHONE = "02-2281-2045";
const BUSINESS_NUMBER = "349-86-02042";
const TAX_NUMBER = "2022-전주덕진-0434";
const JOB_INFO_NUMBER = "J1611020230003";

const DENEER_INFO = {
  회사명: COMPANY_NAME,
  대표이사: REPRESENTATIVE,
  전화번호: PHONE,
  사업자등록번호: BUSINESS_NUMBER,
  "통신판매업 신고번호": TAX_NUMBER,
  직업정보제공사업신고: JOB_INFO_NUMBER,
  주소: ADDRESS,
};

function Footer() {
  return (
    <div className="w-full bg-secondary-100 text-secondary-800 lg:bg-gray-900 lg:text-gray-300">
      <div className="max-w-7xl mx-auto px-6 py-6">
        {/* 상단 섹션 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-4">
          {/* 로고 및 설명 */}
          <div className="space-y-2">
            <div className="lg:hidden">
              <Logo color="black" />
            </div>
            <div className="hidden lg:block">
              <Logo color="white" />
            </div>
            <p className="lg:text-gray-400 text-sm leading-relaxed max-w-md">{DESCRIPTION}</p>
          </div>
          {/* 회사 정보 */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {Object.entries(DENEER_INFO).map(([key, value]) => (
              <div key={key} className="flex flex-col space-y-0.5">
                <span className="text-xs font-medium lg:text-gray-400 uppercase tracking-wide">
                  {key}
                </span>
                <span className="text-sm lg:text-gray-300 break-words">{value}</span>
              </div>
            ))}
          </div>
        </div>

        {/* 구분선 */}
        <div className="border-t border-gray-800 mb-4"></div>

        {/* 하단 섹션 */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center space-y-3 sm:space-y-0">
          {/* 저작권 및 연락처 */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-1 sm:space-y-0 sm:space-x-4">
            <span className="text-sm lg:text-gray-400">
              Copyright ⓒDENEER Corp. All Rights Reserved.
            </span>
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium lg:bg-gray-800 lg:text-gray-300 hover:bg-gray-700 transition-colors">
              문의 cs@deneer.co.kr
            </span>
          </div>

          {/* 링크 메뉴 */}
          <div className="flex flex-wrap items-center space-x-4">
            <button
              className="text-sm lg:text-gray-400 hover:text-white transition-colors duration-200"
              onClick={() => outResource("https://www.ftc.go.kr/bizCommPop.do?wrkr_no=3498602042")}
            >
              사업정보
            </button>
            <Link
              to="/footer/service"
              className="text-sm lg:text-gray-400 hover:text-white transition-colors duration-200"
            >
              이용약관
            </Link>
            <Link
              to="/footer/privacy"
              className="text-sm lg:text-gray-400 hover:text-white transition-colors duration-200"
            >
              개인정보처리방침
            </Link>
            <Link
              to="/footer/financialTransactionTerms"
              className="text-sm lg:text-gray-400 hover:text-white transition-colors duration-200"
            >
              전자금융거래약관
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
